<template>
  <div>
    <PageHeader title="Payment Stub"></PageHeader>
    <v-container>
      <v-row>
        <v-col>
          <div class="honeyBold">
            <v-alert
              type="warning"
            >
            This is a payment simulation. No real money involved.
            </v-alert>
            <p>Your balance will be credited with <b>{{amount}}</b> <b>{{amount === 1 ? "credit" : "credits"}}</b></p>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            outlined
            block
            large
            color="success"
            @click="approvePayment"
            style="color: #ffffff !important;border: 1px solid #ffb300;"
          >
            <v-icon
              left
              dark
              color="green"
            >
              mdi-check
            </v-icon>
            Simulate Payment Approved
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            outlined
            block
            large
            color="error"
            @click="declinePayment"
            style="color: #ffffff !important;border: 1px solid #ffb300;"
          >
            <v-icon
              left
              dark
              color="error"
            >
              mdi-close
            </v-icon>
            Simulate Payment Declined
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-overlay
      :absolute="false"
      :value="overlay"
      :opacity="0.9"
      >
      <v-progress-circular
        indeterminate
        color="amber"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import Socket from "./../../plugins/socket";

export default {
  name: 'paymentstub',
  components: {
    PageHeader
  },
  data: () => ({
    overlay: false
  }),
  computed: {
    amount () {
      return this.$route.query.amount;
    },
    wallet () {
      return this.$store.getters.wallet;
    },
    updatingWalletCredits () {
      return this.$store.getters.updatingWalletCredits;
    }
  },
  methods: {
    reconnect: function () {
      var scope = this;
      console.log('Connectionid is null when approving payment, must get new one.');
      Socket.connect(scope.$store.getters.userSub.userName);
      setTimeout(() => {
        scope.approvePayment();
      }, 2500);
    },
    approvePayment () {
      var scope = this;
      scope.overlay = true;

      if(scope.$store.getters.connectionId === null){
        scope.reconnect();
        return;
      }

      scope.$store.commit('setUpdatingWalletCredits', 1);

      this.$store.dispatch('addWalletTransaction', {
        walletId: scope.wallet.id,
        isDebit: false,
        amount: parseInt(scope.amount),
        notes: 'Buy credits'
      }).then(addWalletTransactionResponse => {
          console.log(`New wallet transaction added [${addWalletTransactionResponse.id}]`);
        }, error => {
            console.log(error);
        });
    },
    declinePayment() {
      this.$router.push({name: 'payment-result', query: {result: 'declined'}});
    },
    updateWallet(){
      var scope = this;
      this.$store.dispatch('getWallet', this.$store.getters.userSub.id).then(response => {
          scope.$localStorage.set('wallet', JSON.stringify(response));
          scope.$store.commit('setWallet', response);
          scope.$store.commit('setUpdatingWalletCredits', 0);
          scope.overlay = false;
          scope.$router.push({name: 'payment-result', query: { result: 'approved'}});
        }, error => {
            console.log(error);
        })
    }
  },
  watch: {
      updatingWalletCredits (newVal) {
        if(newVal === 2) {
          this.updateWallet();
        }
      }
    }
}
</script>